import React from "react";
import { Card, Col, Form, Row, Select } from "antd";
import i18n from "translations/i18n";
import { formatPrice } from "functions/formatters";
import styled from "styled-components";

const { Option } = Select;

// Explicit "no packaging" choice; ProductForm saves it as packagingMaterial: null.
export const NO_PACKAGING = "__none__";

const PackagingMaterialSelector = ({ form, products, disabled }) => {
  const packagingMaterial = Form.useWatch("packagingMaterial", form);
  const isBundle = Form.useWatch("isBundle", form);

  // Filter only packaging materials
  const packagingProducts = products.filter(
    (p) => p.productGroup === "Returnable packaging" || p.productGroup === "Packaging",
  );

  const handlePackagingChange = (productId) => {
    form.setFieldsValue({
      packagingMaterial: { productId, quantity: 1 },
    });
  };

  const getProductById = (productId) => {
    return products.find((p) => p.productId === productId);
  };

  const selectedProduct = packagingMaterial?.productId ? getProductById(packagingMaterial.productId) : null;

  if (!isBundle) return null;

  return (
    <Card title={i18n.t("packaging_material")}>
      <Row gutter={16} align="middle">
        <Col xs={24} md={16}>
          <Form.Item
            name={["packagingMaterial", "productId"]}
            label={i18n.t("select_packaging")}
            rules={[
              {
                required: true,
                message: i18n.t("form.select_packaging_material"),
              },
            ]}
          >
            <Select
              showSearch
              style={{ width: "100%" }}
              placeholder={i18n.t("form.select_packaging_material")}
              optionFilterProp="children"
              onChange={handlePackagingChange}
              disabled={disabled}
              filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
            >
              <Option key={NO_PACKAGING} value={NO_PACKAGING}>
                {i18n.t("no_packaging")}
              </Option>
              {packagingProducts.map((p) => (
                <Option key={p.productId} value={p.productId}>
                  {p.productName}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>

        <Col xs={24} md={8}>
          {selectedProduct && (
            <PackagingPreview>
              <div style={{ fontWeight: 500 }}>{selectedProduct.productName}</div>
              <div>{`€${formatPrice(selectedProduct.price || 0)}`}</div>
            </PackagingPreview>
          )}
        </Col>
      </Row>
    </Card>
  );
};

const PackagingPreview = styled.div`
  padding: 12px;
  background: #fafafa;
  border-radius: 8px;
`;

export default PackagingMaterialSelector;
